import { useSettings } from '../store/settings';
import { isNative } from './platform';

function darkThemeActive(): boolean {
  const forced = document.documentElement.dataset['theme'];
  if (forced === 'dark') return true;
  if (forced === 'light') return false;
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

/**
 * The status bar is transparent over the app's own background (edge to edge), so its icons
 * must follow the theme: light icons on the dark ground, dark icons on the light one.
 */
export async function installStatusBar(): Promise<void> {
  if (!isNative) return;
  const { StatusBar, Style } = await import('@capacitor/status-bar');
  const apply = () => {
    void StatusBar.setStyle({ style: darkThemeActive() ? Style.Dark : Style.Light }).catch(() => undefined);
  };
  apply();
  useSettings.subscribe((s, prev) => {
    if (s.theme !== prev.theme) apply();
  });
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', apply);
}
